import { useEffect } from "react";
import { Button } from "@/frontend/components/ui/button";
import { MessageChart } from "@/frontend/components/MessageChart";
import { UserMenu } from "@/frontend/components/UserMenu";

interface HomePageProps {
  onNavigate: (path: string) => void;
}

export function HomePage({ onNavigate }: HomePageProps) {
  useEffect(() => {
    document.title = "Home";
  }, []);

  return (
    <>
      <UserMenu />
      <div className="container mx-auto p-8 flex flex-col items-center justify-center min-h-screen gap-8">
        <div className="w-full max-w-4xl">
          <MessageChart />
        </div>
        <div className="flex gap-6">
          <Button
            size="default"
            className="text-xl px-8 py-6 h-auto"
            onClick={() => onNavigate("/csm")}
          >
            CSM
          </Button>
          <Button
            size="default"
            className="text-xl px-8 py-6 h-auto"
            onClick={() => onNavigate("/sales")}
          >
            SALES
          </Button>
        </div>
      </div>
    </>
  );
}
